export default "__VITE_ASSET__vWfKWmOi__"